import React from "react";
import { UpdateLocalContactInfoDTO } from "../../../../models/local/local.request";

interface ContactInfoTabProps {
    value: UpdateLocalContactInfoDTO;
    onChange: (value: UpdateLocalContactInfoDTO) => void;
}

const ContactInfoTab: React.FC<ContactInfoTabProps> = ({ value, onChange }) => {

    return (
        <div className="contact-info-block">
            <div className="admin-settings-box-div contact-info">
                <div className="list-header-info">
                    <div className="list-header-title">Kontakt informacije</div>
                    <div className="list-header-description">
                        Načini za kontakt sa vašim lokalom<br />
                    </div>
                </div>
                <div className="info-settings-div">
                    <div className="w-form">
                        <form className="form-4">

                            <div className="div-block-5">
                                <label >Telefon</label>
                                <input className="form-input basic-info w-input" placeholder="Unesite broj telefona" type="tel"
                                    value={value.phoneNumber}
                                    onChange={(e) => onChange({ ...value, phoneNumber: e.target.value })}
                                />
                            </div>

                            <div className="div-block-5">
                                <label >Email</label>
                                <input className="form-input basic-info w-input" placeholder="Unesite email lokala" type="email"
                                    value={value.email}
                                    onChange={(e) => onChange({ ...value, email: e.target.value })}
                                />
                            </div>

                            <div className="div-block-5">
                                <label >Adresa</label>
                                <input className="form-input basic-info w-input" placeholder="Unesite adresu lokala" type="text"
                                    value={value.address}
                                    onChange={(e) => onChange({ ...value, address: e.target.value })}
                                />
                            </div>

                            <div className="div-block-6">
                                <div className="div-block-5">
                                    <label >Longitude <a href="https://www.latlong.net/convert-address-to-lat-long.html" target="_blank" rel="noopener noreferrer">Izracunajte klikom na link</a></label>
                                    <input className="form-input basic-info w-input" placeholder="Unesite longitude" type="text"
                                        value={value.longitude}
                                        onChange={(e) => onChange({ ...value, longitude: e.target.value })}
                                    />
                                </div>

                                <div className="div-block-5">
                                    <label >Latitude</label>
                                    <input className="form-input basic-info w-input" placeholder="Unesite latitude" type="text"
                                        value={value.latitude}
                                        onChange={(e) => onChange({ ...value, latitude: e.target.value })}
                                    />
                                </div>
                            </div>

                            <div className="div-block-5">
                                <label >Web Adresa</label>
                                <input className="form-input basic-info w-input" placeholder="Unesite web adresu lokala (https://..)" type="text"
                                    value={value.website}
                                    onChange={(e) => onChange({ ...value, website: e.target.value })}
                                />
                            </div>

                            <div className="div-block-5">
                                <label >Google Review Link</label>
                                <input className="form-input basic-info w-input" placeholder="Unesite web adresu lokala (https://..)" type="text"
                                    value={value.googleReviewURL}
                                    onChange={(e) => onChange({ ...value, googleReviewURL: e.target.value })}
                                />
                            </div>

                        </form>
                    </div>
                </div>
            </div>
            <div className="admin-settings-box-div contact-info">
                <div className="list-header-info">
                    <div className="list-header-title">Društvene mreže</div>
                    <div className="list-header-description">
                        Linkovi ka vašim profilima<br />
                    </div>
                </div>
                <div className="info-settings-div">
                    <div className="w-form">
                        <form className="form-4">

                            <div className="div-block-6">
                                <div className="div-block-5">
                                    <label >Facebook</label>
                                    <input className="form-input basic-info w-input" placeholder="Unesite ime profila" type="text"
                                        value={value.socialLinks?.[0]?.name}
                                        onChange={(e) => onChange({ ...value, socialLinks: { ...value.socialLinks, [0]: { name: e.target.value, url: value.socialLinks?.[0]?.url } } })}
                                    />
                                </div>

                                <div className="div-block-5">
                                    <label >Url</label>
                                    <input className="form-input basic-info w-input" placeholder="Unesite url profila (https://)" type="text"
                                        value={value.socialLinks?.[0]?.url}
                                        onChange={(e) => onChange({ ...value, socialLinks: { ...value.socialLinks, [0]: { name: value.socialLinks?.[0]?.name, url: e.target.value } } })}
                                    />
                                </div>
                            </div>

                            <div className="div-block-6">
                                <div className="div-block-5">
                                    <label >Instagram</label>
                                    <input className="form-input basic-info w-input" placeholder="Unesite ime profila" type="text"
                                        value={value.socialLinks?.[1]?.name}
                                        onChange={(e) => onChange({ ...value, socialLinks: { ...value.socialLinks, [1]: { name: e.target.value, url: value.socialLinks?.[1]?.url } } })}
                                    />
                                </div>

                                <div className="div-block-5">
                                    <label >Url</label>
                                    <input className="form-input basic-info w-input" placeholder="Unesite url profila (https://)" type="text"
                                        value={value.socialLinks?.[1]?.url}
                                        onChange={(e) => onChange({ ...value, socialLinks: { ...value.socialLinks, [1]: { name: value.socialLinks?.[1]?.name, url: e.target.value } } })}
                                    />
                                </div>
                            </div>

                            <div className="div-block-6">
                                <div className="div-block-5">
                                    <label >Tiktok</label>
                                    <input className="form-input basic-info w-input" placeholder="Unesite ime profila" type="text"
                                        value={value.socialLinks?.[4]?.name}
                                        onChange={(e) => onChange({ ...value, socialLinks: { ...value.socialLinks, [4]: { name: e.target.value, url: value.socialLinks?.[4]?.url } } })}
                                    />
                                </div>

                                <div className="div-block-5">
                                    <label >Url</label>
                                    <input className="form-input basic-info w-input" placeholder="Unesite url profila (https://)" type="text"
                                        value={value.socialLinks?.[4]?.url}
                                        onChange={(e) => onChange({ ...value, socialLinks: { ...value.socialLinks, [4]: { name: value.socialLinks?.[4]?.name, url: e.target.value } } })}
                                    />
                                </div>
                            </div>

                            <div className="div-block-6">
                                <div className="div-block-5">
                                    <label >Youtube</label>
                                    <input className="form-input basic-info w-input" placeholder="Unesite ime profila" type="text"
                                        value={value.socialLinks?.[5]?.name}
                                        onChange={(e) => onChange({ ...value, socialLinks: { ...value.socialLinks, [5]: { name: e.target.value, url: value.socialLinks?.[5]?.url } } })}
                                    />
                                </div>

                                <div className="div-block-5">
                                    <label >Url</label>
                                    <input className="form-input basic-info w-input" placeholder="Unesite url profila (https://)" type="text"
                                        value={value.socialLinks?.[5]?.url}
                                        onChange={(e) => onChange({ ...value, socialLinks: { ...value.socialLinks, [5]: { name: value.socialLinks?.[5]?.name, url: e.target.value } } })}
                                    />
                                </div>
                            </div>

                            <div className="div-block-6">
                                <div className="div-block-5">
                                    <label >LinkedIn</label>
                                    <input className="form-input basic-info w-input" placeholder="Unesite ime profila" type="text"
                                        value={value.socialLinks?.[3]?.name}
                                        onChange={(e) => onChange({ ...value, socialLinks: { ...value.socialLinks, [3]: { name: e.target.value, url: value.socialLinks?.[3]?.url } } })}
                                    />
                                </div>

                                <div className="div-block-5">
                                    <label >Url</label>
                                    <input className="form-input basic-info w-input" placeholder="Unesite url profila (https://)" type="text"
                                        value={value.socialLinks?.[3]?.url}
                                        onChange={(e) => onChange({ ...value, socialLinks: { ...value.socialLinks, [3]: { name: value.socialLinks?.[3]?.name, url: e.target.value } } })}
                                    />
                                </div>
                            </div>

                            <div className="div-block-6">
                                <div className="div-block-5">
                                    <label >X / Twitter</label>
                                    <input className="form-input basic-info w-input" placeholder="Unesite ime profila" type="text"
                                        value={value.socialLinks?.[2]?.name}
                                        onChange={(e) => onChange({ ...value, socialLinks: { ...value.socialLinks, [2]: { name: e.target.value, url: value.socialLinks?.[2]?.url } } })}
                                    />
                                </div>

                                <div className="div-block-5">
                                    <label >Url</label>
                                    <input className="form-input basic-info w-input" placeholder="Unesite url profila (https://)" type="text"
                                        value={value.socialLinks?.[2]?.url}
                                        onChange={(e) => onChange({ ...value, socialLinks: { ...value.socialLinks, [2]: { name: value.socialLinks?.[2]?.name, url: e.target.value } } })}
                                    />
                                </div>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>
    );

};

export default ContactInfoTab;